import React, { useEffect, useState } from 'react';
import { Card, Table, Pagination, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer, { initialState } from './reducer';
import saga from './saga';
import _ from 'lodash';
// import ConfirmModal from 'components/ConfirmModal';
import { listMessage, toggleDrawer } from './action';
import AddWelcomeMessageDrawer from 'components/AddMessageDrawer';
import { MessageTableConfig } from './MessageTableConfig';

function WelcomeMessage() {
  useInjectReducer({ key: 'message', reducer });
  useInjectSaga({ key: 'message', saga });
  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [searchedColumn, setSearchedColumn] = useState(null);
  const [deleteModalToggle, setDeleteModalToggle] = useState(false);
  const [selectedMessage, setselectedMessage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const messageState = useSelector((state) => state.message || initialState);
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  useEffect(() => {
    const columns = MessageTableConfig(
      handleSearch,
      handleReset,
      // onDelete,
      editUserMessage,
      authState.userResponsibilities,
    );
    setColumns(columns);
    dispatch(listMessage({ page: 1, limit: 10 }));
  }, []);

  // const onDelete = (item) => {
  //   if (!_.isNil(item)) {
  //     setselectedMessage(item);
  //     dispatch(toggleDeleteModal());
  //     return;
  // };
  // dispatch(deleteQuote(selectedMessage.quote_id));
  // console.log(item);
  // }
  const resetPagination = () => setCurrentPage(1);

  const editUserMessage = (message) => {
    setselectedMessage(message);
    dispatch(toggleDrawer());
  };

  const onPageChange = (page, pageSize) => {
    let filter = { page, limit: pageSize };
    setCurrentPage(page);
    if ((searchedColumn, searchText)) {
      filter = { ...filter, [searchedColumn]: searchText };
    }
    dispatch(listMessage(filter));
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length <= 0) {
      message.error('Please select to search');
      return;
    }
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    dispatch(listMessage({ page: 1, limit: 10, [dataIndex]: selectedKeys[0] }));
    resetPagination();
  };
  // const handleDeleteModalToggle = () => dispatch(toggleDeleteModal());

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText(null);
    setSearchedColumn(null);
    dispatch(listMessage({ page: 1, limit: 10 }));
    resetPagination();
  };
  return (
    <>
      <Card
        title="Welcome Message"
        extra={
          <AddWelcomeMessageDrawer
            initialState={initialState}
            selectedMessage={selectedMessage}
            resetPagination={resetPagination}
            editUserMessage={editUserMessage}
            roleAddResponsibility={_.includes(
              authState.userResponsibilities,
              'ADD_MESSAGE_BUTTON',
            )}
          />
        }
      >
        <Table
          columns={columns}
          loading={messageState.loading}
          bordered
          pagination={false}
          size={'small'}
          dataSource={messageState.data}
          style={{ height: '70vh', overflow: 'scroll' }}
        />
        <Pagination
          style={{ marginTop: '10px' }}
          total={messageState.totalCount}
          showTotal={(total) => `Total ${total} items`}
          defaultPageSize={10}
          current={currentPage}
          showLessItems={true}
          showSizeChanger={false}
          disabled={messageState.loading}
          onChange={onPageChange}
        />
      </Card>
      {/* <ConfirmModal
        title={'Delete Quote Confirmation'}
        text={'Are you sure you want to delete this quote ?'}
        toggle={messageState.deleteModal}
        loading={messageState.loading}
        handleDeleteModalToggle={handleDeleteModalToggle}
        onDelete={onDelete}
      /> */}
    </>
  );
}

export default WelcomeMessage;
